import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { ValueTransition } from '@ynap/value-transition';
import { useContentByComponentKey } from '@ynap/content-hook';

const bem = new BEMHelper('DesignerDetails');

export const getComponentKey = (seoURLKeyword, gender) => {
    const designerName = seoURLKeyword && seoURLKeyword.split('/').pop();
    return designerName && gender ? (gender === 'womens' ? `sale-category-${designerName}` : `sale-category-mens-${designerName}`) : null;
};

export const getContentByComponentKey = (contentByComponentKey) => {
    if (!contentByComponentKey) {
        return {};
    }

    return {
        title: contentByComponentKey?.content?.[0]?.teaser?.teaserTitle,
        content: contentByComponentKey?.content?.[0]?.teaser?.teaserTextPlain,
    };
};

const DesignerDetails = (props) => {
    const {
        designerSeo: { seoURLKeyword },
        gender,
    } = props;

    const componentKey = getComponentKey(seoURLKeyword, gender);

    const { content: { title: designerTitle = '', content: designerContent = '' } = {} } =
        componentKey &&
        useContentByComponentKey({
            componentKey,
            normalize: getContentByComponentKey,
        });

    return (
        designerContent && (
            <div className={bem()}>
                <div className={bem('wrapper')}>
                    <ValueTransition component="h2" className={bem('title')} classAnimationModifier={bem('title', 'changing')} animationName="fadeOut">
                        {designerTitle}
                    </ValueTransition>
                    <ValueTransition component="p" className={bem('content')} classAnimationModifier={bem('content', 'changing')} animationName="fadeOut">
                        {designerContent}
                    </ValueTransition>
                </div>
            </div>
        )
    );
};

DesignerDetails.propTypes = {
    designerSeo: PropTypes.object.isRequired,
    baseUrl: PropTypes.string.isRequired,
    brandId: PropTypes.string.isRequired,
    coreMediaLocale: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    clientId: PropTypes.string.isRequired,
    gender: PropTypes.string.isRequired,
};

export default DesignerDetails;
